import { Stack, Typography } from '@chronosphereio/chrono-ui';
import { Group } from '@/dashboards/components/Builder';
import { FILTER_OPERATORS, Filter, FilterOperator, isRegexOperator } from '../promql-builder-model';

const { RegexEqual, RegexNotEqual, Equal, NotEqual } = FILTER_OPERATORS;

const OPERATOR_SYMBOL_WIDTH = '20px';
const OPERATOR_OPTIONS = [
  {
    value: Equal,
    label: (
      <Stack direction="row" spacing={1}>
        <Typography variant="code" width={OPERATOR_SYMBOL_WIDTH}>
          =
        </Typography>
        <Typography variant="body2">equals</Typography>
      </Stack>
    ),
  },
  {
    value: NotEqual,
    label: (
      <Stack direction="row" spacing={1}>
        <Typography variant="code" width={OPERATOR_SYMBOL_WIDTH}>
          !=
        </Typography>
        <Typography variant="body2">does not equal</Typography>
      </Stack>
    ),
  },
  {
    value: RegexEqual,
    label: (
      <Stack direction="row" spacing={1}>
        <Typography variant="code" width={OPERATOR_SYMBOL_WIDTH}>
          =~
        </Typography>
        <Typography variant="body2">matches</Typography>
      </Stack>
    ),
  },
  {
    value: RegexNotEqual,
    label: (
      <Stack direction="row" spacing={1}>
        <Typography variant="code" width={OPERATOR_SYMBOL_WIDTH}>
          !~
        </Typography>
        <Typography variant="body2">does not match</Typography>
      </Stack>
    ),
  },
];

type FilterOperatorSelectorProps = {
  filter: Filter;
  onFilterChange: (filter: Filter) => void;
};

export function FilterOperatorSelector({ filter, onFilterChange }: FilterOperatorSelectorProps) {
  const operator = filter.operator ?? RegexEqual;

  return (
    <Group.ButtonMenu
      value={operator}
      label={operator}
      options={OPERATOR_OPTIONS}
      onSelect={(option) => {
        const newOperator = option as FilterOperator;
        onFilterChange({
          ...filter,
          operator: newOperator,
          values: isRegexOperator(newOperator) ? filter.values : filter.values.slice(0, 1),
        });
      }}
    />
  );
}
